import { LogbookSettingsState, MESFMain } from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import { createRoot } from "react-dom/client";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./setup/nprogress";

const logbookSettings = {
	entry: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		allowAttachments: true,
		canEditAsset: true,
		exportToExcel: true,
		useShiftNavigatorBasedOnAsset: true,
	},
	report: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		showAttachments: true,
		showAsset: true,
		exportToExcel: true,
	},
} as Partial<LogbookSettingsState>;

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			cacheTime: 1000 * 60,
		},
	},
});
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
	<QueryClientProvider client={queryClient}>
		<MESFMain
			showAreaSelector={true}
			routes={CustomRoutes}
			navbarTitle={"SWV MILL"}
			navbar={CustomNavbar}
			authentication={AuthenticationConfig}
			configurations={customConfigurations}
			logbookSettings={logbookSettings}
		/>
	</QueryClientProvider>,
);
